import { Component, OnInit, inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogClose,
  MatDialogContent,
  MatDialogActions
} from "@angular/material/dialog";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule
} from "@angular/forms";
import { MatIconButton, MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { ColorPickerDirective } from "ngx-color-picker";
import { TranslatePipe } from "@ngx-translate/core";

interface ColorChooserData {
  currentBackground: string;
  currentForeground: string;
}

interface ColorChooserResult {
  success: boolean;
  backgroundColor: string;
  foregroundColor: string;
}

@Component({
  selector: "app-color-chooser",
  templateUrl: "./color-chooser.component.html",
  styleUrls: ["./color-chooser.component.scss"],
  standalone: true,
  imports: [
    MatIconButton,
    MatDialogClose,
    MatIcon,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    ColorPickerDirective,
    MatDialogActions,
    MatButton,
    TranslatePipe
  ]
})
export class ColorChooserComponent implements OnInit {
  private dialogRef =
    inject<MatDialogRef<ColorChooserComponent, ColorChooserResult>>(
      MatDialogRef
    );
  private fb = inject(FormBuilder);
  private data = inject<ColorChooserData>(MAT_DIALOG_DATA);

  chooserForm: FormGroup;
  backgroundColor: string;
  foregroundColor: string;

  constructor() {
    const data = this.data;

    this.backgroundColor = data.currentBackground;
    this.foregroundColor = data.currentForeground;
  }

  ngOnInit(): void {
    this.chooserForm = this.fb.group({
      backgroundColor: [this.data.currentBackground],
      foregroundColor: [this.data.currentForeground]
    });
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  colourChanged(): void {
    this.chooserForm.markAsDirty();
  }

  save(): void {
    this.dialogRef.close({
      success: true,
      backgroundColor: this.backgroundColor,
      foregroundColor: this.foregroundColor
    });
  }
}
